import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import CircleIcon from '@mui/icons-material/Circle';

const dummy = [
    {
        label: "Very Conservative",
        value: 51,
    },
    {
        label: "Conservative",
        value: 50,
    },
    {
        label: "Moderate",
        value: 56,
    },
    {
        label: 'Aggressive',
        value: 24,
    },
    {
        label: 'Very Aggressive',
        value: 69,
    }
]

const MultipleCart = () => {
    return (
        <Grid container rowGap={1} columnGap={1} sx={{ height: '100%' }}>
            {dummy.map((ele, index) => (
                <InfoCart key={index} {...{ ...ele, index }} />
            ))}
        </Grid>
    )
}

export default MultipleCart


const color = ['#00E676', '#FFF176', "#FFF176", "#FF6E40", "#DD2C00"]

const InfoCart = ({ label, value, index }: { label: string, value: number, index: number }) => {
    return (
        <Grid item sx={{
            background: '#FFFFFF',
            borderRadius: '20px',
            boxShadow: '0px 4px 10px 0px #0000000D',
            padding: '15px 20px 15px 20px',
            width: '100%',
            height: { lg: '48%', md: 'fit-content', sm: 'fit-content', xs: 'fit-content' },
        }} lg={index > 2 ? 5.8 : 3.8} md={index > 2 ? 5.8 : 3.8} sm={12} xs={12}>
            <Box sx={{ display: 'flex', gap: '5px', flexDirection: 'row', alignItems: 'center' }}>
                <CircleIcon sx={{ color: color[index], width: '11px', height: '11px' }} />
                <Typography variant='body_500' sx={{ textWrap: 'nowrap' }}>{label}</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: '5px', flexDirection: 'row', alignItems: 'center' }}>
                <CircleIcon sx={{ color: "transparent", width: '11px', height: '11px' }} />
                <Typography variant='body_600'>
                    {value}
                </Typography>
            </Box>
        </Grid>
    )
}